import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router'; // 1. Importa el componente del Router

@Component({
  selector: 'app-root',
  standalone: true, // Asegúrate de que esto esté así
  imports: [RouterOutlet], // 2. Añádelo aquí
  templateUrl: './app.html',
  styleUrls: ['./app.scss']
})
export class AppComponent {
  title = 'i';
}
